import { render, staticRenderFns } from "./baibanReport.vue?vue&type=template&id=5f3e2daa&scoped=true"
import script from "./baibanReport.vue?vue&type=script&lang=js"
export * from "./baibanReport.vue?vue&type=script&lang=js"
import style0 from "./baibanReport.vue?vue&type=style&index=0&id=5f3e2daa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3e2daa",
  null
  
)

export default component.exports